export enum Pages {
  // Login
  EMAIL_AUTH = "email_auth",
  LOGIN = "login",
  FORGOT_PASSWORD = "forgot_password",
  RESET_PASSWORD = "reset_password",
  RESET_PASSWORD_CODE = "reset_password_code",
  SET_NEW_PASSWORD = "set_new_password",

  // Menu sections
  SEARCH = "search",
  REPORTS = "reports",
  DISPUTES = "disputes",
  INVENTORY = "inventory",
  COLLECTIONS_DASHBOARD = "collection_dashboard",
  ACCOUNT_INFORMATION = "account_information",
  IMPORT_DIRECT_PAYMENT = "import_direct_payment",
  IMPORT_RECALLS = "import_recalls",
  PLACE_ACCOUNTS = "place_accounts",
  CONTACT_US = "contact_us",

  // Account
  DIRECT_PAYMENT_DIALOG = "direct_payment_dialog",
  RECALL_REQUEST_DIALOG = "recall_request_dialog",
  DOCUMENTS_TAB = "documents_tab",
  UPLOAD_DOCUMENTS_DIALOG = "upload_documents_dialog",
  TIMELINE_TAB = "timeline_tab",

  PARTNER_SELECTOR = "partner_selector",
  DOCUMENT_REQUESTS = "document_requests",
  UPLOAD_DOCUMENT_REQUESTS_DIALOG = "upload_document_requests_dialog",
}
